/* this file is transformed by vux-loader */
/* eslint-disable */
import base from '../base';
import http from '../http';
var Approver = {
  selectApprovalUser: function selectApprovalUser(params) {
    return http.post("".concat(base.dev, "/management/selectApprovalUser"), params);
  }
};
export default Approver;